import { useI18n } from '@monorepo/i18n';
import { useNotifications } from '@monorepo/notification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LockEmployeeRequest } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { UserBriefInfo } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { getGrpcPromise, TGRPCPromiseReject } from '@monorepo/grpc';
import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';
import { useCallback } from 'react';
import { QUERY_KEYS } from '@monorepo/helpers';

const useLockMerchandiser = () => {
  const { t } = useI18n();
  const { errorNotification, successNotification } = useNotifications();
  const queryClient = useQueryClient();

  const mutator = (
    data: Partial<LockEmployeeRequest.AsObject>
  ): Promise<UserBriefInfo.AsObject> => {
    const request = new LockEmployeeRequest();
    if (data.userId) {
      request.setUserId(data.userId);
    }
    if (data.reason) {
      request.setReason(data.reason);
    }

    return getGrpcPromise(WebAuthService.LockEmployee)(request);
  };

  const onSuccess = useCallback(() => {
    successNotification(t('updateUser.success'));
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
  }, [t, successNotification]);

  const onError = useCallback(
    (error: TGRPCPromiseReject) =>
      errorNotification(t(`updateUser.error.${error.status}`)),
    [t, errorNotification]
  );

  return useMutation({ mutationFn: mutator, retry: false, onSuccess, onError });
};

export default useLockMerchandiser;
